import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getUserKeys } from "@/api";
import { Message } from "@arco-design/web-react";

interface AuthGuardProps {
	children: React.ReactNode;
	requireAuth?: boolean; // 是否需要认证，默认true
}

const AuthGuard: React.FC<AuthGuardProps> = ({
	children,
	requireAuth = true,
}) => {
	const history = useHistory();
	const [isChecking, setIsChecking] = useState(true);
	const [isAuthenticated, setIsAuthenticated] = useState(false);

	useEffect(() => {
		const checkAuth = async () => {
			try {
				// 调用API验证身份
				await getUserKeys();
				setIsAuthenticated(true);
			} catch (error) {
				const statusCode =
					error?.response?.status || error?.response?.data?.statusCode;

				if (requireAuth && (statusCode === 401 || statusCode === 403)) {
					setIsChecking(false);
					// Message.warning(error.response.data.message);
					Message.warning("身份验证失败，请重新登录");

					// 跳转到登录页，并保存当前路径
					setTimeout(() => {
						history.push("/login", {
							replace: true,
							state: { from: location.pathname }, // 登录后可以返回原页面
						});
					}, 1500);
					return;
				}

				// 对于不需要认证的页面，继续显示
				if (!requireAuth) {
					setIsAuthenticated(true);
				}
			} finally {
				setIsChecking(false);
			}
		};

		checkAuth();
	}, [location.pathname]);

	// 显示验证状态
	if (isChecking) {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100vh",
					fontSize: "16px",
					color: "#666",
				}}
			>
				🔐 正在验证身份...
			</div>
		);
	}

	// 只有认证通过才显示内容
	return isAuthenticated ? <>{children}</> : null;
};

export default AuthGuard;
